import type { ImageWithLink, SanityLink, SanityLinkCategory } from '$lib/types/sanityComponents';
import { sanityWebsiteClient } from './sanityWebsiteClient';

interface Footer {
	socialTitle: string;
	socialIcons: ImageWithLink[];
	linkCategories: SanityLinkCategory[];
	legalLinks: SanityLink[];
}

export function getFooter(): Promise<Footer> {
	return sanityWebsiteClient.fetch(
		`*[_type == "footer"] {
            socialTitle,
            socialIcons[]{ "assetId": image.image.asset._ref, "alt": image.alt, url },
            linkCategories[]{ title, links[]{ label, external, url } },
            legalLinks[]{ label, external, url },
        }[0]`
	);
}
